import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function updatePermohonanData(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.put(`${apiUrl}/permohonan/update`, body, config);
  return data;
}

export async function signDocument(formData) {
  config.headers = { 'Content-Type': 'multipart/form-data', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/permohonan/sign`, formData, config);
  return data;
}

export async function signUpload(formData) {
  config.headers = { 'Content-Type': 'multipart/form-data', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/permohonan/signupload`, formData, config);
  return data;
}

export async function signUpdateDocument(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/permohonan/signupdate`, body, config);
  return data;
}
